function easeInOutSin(time: number): number {
  return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}

type AnimateScrollParams = {
  property: 'scrollLeft' | 'scrollTop';
  element: HTMLElement;
  to: number;
  options?: { duration?: number; ease?: (t: number) => number };
};

/**
 * Smoothly animates an element's scroll property from its current value to a target value
 * using requestAnimationFrame. Ported from MUI's internal animate utility.
 *
 * @returns A cancel function that stops the animation.
 */
export const animateScroll = ({
  property,
  element,
  to,
  options,
}: AnimateScrollParams) => {
  const { ease = easeInOutSin, duration = 300 } = options || {};

  let start: number | null = null;
  const from = element[property];
  let cancelled = false;

  const cancel = () => {
    cancelled = true;
  };

  const step = (timestamp: number) => {
    if (cancelled) {
      return;
    }

    if (start === null) {
      start = timestamp;
    }

    const time = Math.min(1, (timestamp - start) / duration);
    element[property] = ease(time) * (to - from) + from;

    if (time >= 1) {
      return;
    }

    requestAnimationFrame(step);
  };

  if (from === to) {
    return cancel;
  }

  requestAnimationFrame(step);
  return cancel;
};
